import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnboardingInfoCardComponent } from '../../ui/onboarding-info-card/onboarding-info-card.component';

@Component({
  selector: 'app-onboarding-step-two',
  imports: [OnboardingInfoCardComponent, NgOptimizedImage, TranslatePipe],
  templateUrl: './onboarding-step-two.component.html',
  styleUrl: '../step.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingStepTwoComponent {}
